import { render, staticRenderFns } from "./region-grid.vue?vue&type=template&id=66b8d789&"
import script from "./region-grid.vue?vue&type=script&lang=js&"
export * from "./region-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports